export const mbToBytes = (num: number) => num * 1048576;
